<template>
    <nav class="navigation" role="navigation">
        <NavigationNode class="navigation__list" :routes="routes"/>
    </nav>
</template>

<script>
import NavigationNode from "./NavigationNode.vue";

export default {
    components: {NavigationNode},
    emits: ['navigation'],

    computed: {
        routes() {
            return this.$router.options.routes;
        }
    }
}
</script>

<style lang="scss">
.navigation {
    &__list {
        display: flex;
        gap: var(--gap-thin);
        font-weight: bold;

        .router-link-active {
            text-decoration: underline;
        }
    }
}
</style>
